<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template #option="{ label, products_count }">
            {{ label }}<span v-if="showCount" class="text-muted ml-1"> ({{ products_count }})</span>
        </template>
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på kategori</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import CategoryRepository from '@services/repositories/Product/CategoryRepository';

export default {
    name: 'CategoryFilter',
    components: {
        VueSelect,
    },
    props: {
        showCount: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        const client = new CategoryRepository();
        client.getAll().then((res) => {
            this.options = res.filter((item) => item.type === 'category').map((item) => ({
                id: item.ProdCatID,
                label: item.categoryName,
                products_count: item.products_count,
            }));
        });
    },
};
</script>
